import { TrackedListColumns } from "../pages/tracked-lists/enum/tracked-list-columns";

export const trackedListColumns = [
    {
        id: TrackedListColumns.LIST_ID,
        name: "List ID",
        width: 70,
    },
    {
        id: TrackedListColumns.NAME,
        name: "List Name",
        width: "35%",
    },
    {
        id: TrackedListColumns.LAST_UPDATED,
        name: "Last Updated",
        width: "20%",
    },
    {
        id: TrackedListColumns.RECORDS,
        name: "Location Count",
        width: "20%",
    },
];
